import StyleSheet from 'react-native-media-query';
import {
  COLORS,
  FONT_NAMES,
  FixedValue,
  Percentage,
  BASESTYLE,
  GlobalStyleValues,
} from '../../constants';
import {IColorTheme} from '../../types/contextTypes/themeContext';
import {normalizeFont, scaleHeight, scaleWidth} from '../../utils/responsive';

export const style = (theme: IColorTheme) =>
  StyleSheet.create({
    subContainer: {
      width: Percentage.PRECENTAGE_100,
      backgroundColor: theme.backgroundColor,
      paddingHorizontal: scaleWidth(FixedValue.CONSTANT_VALUE_20),
      paddingTop: scaleHeight(FixedValue.CONSTANT_VALUE_15),
      paddingBottom: scaleHeight(FixedValue.CONSTANT_VALUE_18),
      borderTopLeftRadius: FixedValue.CONSTANT_VALUE_18,
      borderTopRightRadius: FixedValue.CONSTANT_VALUE_18,
      shadowColor: COLORS._333333,
      shadowOffset: {
        width: FixedValue.CONSTANT_VALUE_0,
        height: -FixedValue.CONSTANT_VALUE_3,
      },
      shadowOpacity: FixedValue.CONSTANT_VALUE_03,
      elevation: FixedValue.CONSTANT_VALUE_3,
    },
    container: {
      ...BASESTYLE.inRow,
      ...BASESTYLE.spaceBetween,
      marginBottom: scaleHeight(FixedValue.CONSTANT_VALUE_21),
    },
    titleText: {
      fontSize: normalizeFont(FixedValue.CONSTANT_VALUE_20),
      fontFamily: FONT_NAMES.SF_MEDIUM,
      color: theme.color,
    },
    notePressable: {
      paddingHorizontal: scaleWidth(FixedValue.CONSTANT_VALUE_16),
      borderRadius: scaleWidth(FixedValue.CONSTANT_VALUE_8),
      paddingVertical: scaleHeight(FixedValue.CONSTANT_VALUE_6),
    },
    notePressableSecond: {
      paddingVertical: scaleHeight(FixedValue.CONSTANT_VALUE_6),
      paddingHorizontal: scaleWidth(FixedValue.CONSTANT_VALUE_16),
      borderRadius: scaleWidth(FixedValue.CONSTANT_VALUE_8),
       marginBottom: scaleHeight(FixedValue.CONSTANT_VALUE_15),
    },
    noteText: {
      fontSize: normalizeFont(FixedValue.CONSTANT_VALUE_16),
      color: theme.color,
      paddingLeft: scaleWidth(FixedValue.CONSTANT_VALUE_5),
    },
    noteRow: {
      flexDirection: GlobalStyleValues.ROW,
      alignItems: GlobalStyleValues.CENTER,
      gap: FixedValue.CONSTANT_VALUE_5,
      marginRight: scaleWidth(FixedValue.CONSTANT_VALUE_30),
    },
    noteTextContainer: {
      marginHorizontal: scaleWidth(FixedValue.CONSTANT_VALUE_25),
    },
  });
